<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox></navBox>
			<!--导航-->
			<!--banner-->
			<div v-if="infoData" class="banner_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<van-swipe ref="swipeBox" class="swipe_box" :autoplay="0" :show-indicators="false" :stop-propagation="false" @change="bannerChange">
					<!-- <van-swipe-item v-for="(value, index) in infoData.image_list" :key="index">
						<div class="swiper_el">
							<img class="bg" :src="webUrl + value.url" @dragstart.prevent />
						</div>
					</van-swipe-item> -->
					<van-swipe-item>
						<div class="swiper_el">
							<img class="bg" :src="webUrl + infoData.thumb" @dragstart.prevent />
						</div>
					</van-swipe-item>
				</van-swipe>
				<!-- <div v-if="infoData.image_list.length > 2" class="swiper_bot">
					<div class="icon" style="margin-right: 5px;" @click="prevBanner">
						<van-icon name="arrow-left" size="20px" color="#999999" />
					</div>
					<div class="swiper_el" :class="bannerIndex == index ? 'actived' : ''" v-for="(value, index) in infoData.image_list" :key="index">
						<img class="bg" :src="webUrl + value.url" />
					</div>
					<div class="icon" style="margin-left: 5px;" @click="nextBanner">
						<van-icon name="arrow" size="20px" color="#999999" />
					</div>
				</div> -->
			</div>
			<!--banner-->
			<!--块1-->
			<div v-if="infoData" class="block_1"
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tips">{{ $t('product.text17') }}</div>
				<div class="tit">{{ infoData.name }}</div>
				<div class="txt" style="padding-top: 30px;">{{ infoData.description }}</div>
				<div class="txt" style="padding-top: 25px;">{{ infoData.guige }}</div>
				<div class="btn_box">
					<div class="btn_back" @click="goProduct">
						<van-icon name="arrow-left" size="16px" class="btn_icon" style="top: 3px;" />&ensp;Back to Product list
					</div>
					<div class="btn_contact" @click="goContact">{{ $t('product.text18') }}</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<template v-if="infoData">
				<div v-if="infoData.content" class="block_2"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="tit_box">
						<div class="tit">{{ $t('product.text19') }}</div>
					</div>
					<div class="content_box" v-html="infoData.content"></div>
				</div>
			</template>
			<!--块2-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/h5/nav.vue'  //导航组件
import footerBox from '@/component/h5/footer.vue'  //版权组件
import { UPURL } from '@/util/util';
import { productInfo, productCount } from '@/api/public'
import md5 from 'js-md5';
import moment from 'moment';
export default {
	components:{
		navBox,
		footerBox
	},
	data() {
		return {
			isLoading: true,  //界面loading
			bannerIndex: 0,  //当前轮播索引
			webUrl: UPURL,
			infoData: null,
		}
	},
	created(){
		let that = this;
		//请求产品详情
		if(that.$route.params.productInfoId) {
			that.$toast.loading({ message: '', forbidClick: true, duration: 0 });
			productInfo({ id: that.$route.params.productInfoId.split('.')[0] }).then(res => {
				that.infoData = res.data;
				that.$toast.clear();//访问统计
				let time = String(moment().unix());
				setTimeout(() => {
					productCount({
						language: sessionStorage.getItem('lang'),
						productid: that.infoData.id,
						cate_id: that.infoData.cate_id,
						scenarios_id: that.infoData.scenarios_id ? that.infoData.scenarios_id : '',
						cert_id: that.infoData.cert_id ? that.infoData.cert_id : '',
						url: that.$route.name,
						addtime: time,
						sign: md5(String(that.infoData.cate_id) + String(that.infoData.scenarios_id ? that.infoData.scenarios_id : '') + String(that.infoData.cert_id ? that.infoData.cert_id : '') + String(that.infoData.id) + that.$route.name + String(time) + 'Coretests2024'),
					}).then(res => {});
				}, 10000);
			});
		}else {
			that.$toast(that.$t('product.text20'));
		}
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//点击产品中心
		goProduct() {
			this.$router.push({ path: '/product-list.html' });
		},
		//跳转联系我们
		goContact() {
			this.$router.push({ path: '/about/contact.html' });
		},
		//banner变化
		bannerChange(index) {
			let that = this;
			that.bannerIndex = index;
		},
		//prevBanner
		prevBanner() {
			let that = this;
			that.$refs.swipeBox.prev();
		},
		//nextBanner
		nextBanner() {
			let that = this;
			that.$refs.swipeBox.next();
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	//块2
	.block_2{
		padding: 30px 20px 50px 20px;
		border-top: 10px solid #F7F6F9;
		.tit_box{
			margin-bottom: 30px;
			border-bottom: 1px solid #ECE7E8;
			.tit{
				display: inline-block;
				font-size: 18px;
				font-weight: bold;
				border-bottom: 1px solid #A20073;
				line-height: 1.8;
			}
		}
	}
	//块1
	.block_1{
		padding: 40px 20px;
		.btn_box{
			padding-top: 30px;
			text-align: center;
			.btn_contact{
				display: inline-block;
				padding: 8px 16px;
				font-size: 16px;
				color: #ffffff;
				background: linear-gradient( 90deg, #CF0272 0%, #A20073 100%);
				border-radius: 8px 8px 8px 8px;
				cursor: pointer;
			}
			.btn_back{
				display: inline-block;
				margin-right: 20px;
				padding: 8px 16px 8px 14px;
				font-size: 16px;
				border-radius: 8px 8px 8px 8px;
				cursor: pointer;
				color: #A50073;
				border: 1px solid #A50073;
			}
		}
		.txt{
			padding-top: 12px;
			white-space: pre-wrap;
			line-height: 1.8;
		}
		.tit{
			padding-top: 6px;
			font-size: 18px;
			font-weight: bold;
		}
		.tips{
			display: inline-block;
			padding: 4px 8px;
			color: #A50073;
			background-color: #F3E6F0;
			border-radius: 8px;
		}
	}
	//轮播
	.banner_box{
		padding: 20px 20px 20px 20px;
		background: url(../../assets/img_public/products/info_block01.webp) no-repeat 100% 100%;
		background-size: cover;
		.swiper_bot{
			display: flex;
			align-items: center;
			padding: 30px 0;
			cursor: pointer;
			user-select: none;
			.swiper_el{
				flex: 1;
				margin: 0 5px;
				border-radius: 8px;
				overflow: hidden;
				img{
					width: 100%;
				}
			}
			.swiper_el.actived{
				border: 1px solid #A20073;
			}
			.icon{
				width: auto;
			}
		}
		.swipe_box{
			width: 100%;
			.swiper_el{
				img{
					width: 100%;
				}
			}
		}
	}
}
</style>
<style scoped>
>>> .main_box ol,>>> .main_box ul{
	list-style: initial !important;
	margin: revert !important;
	padding: revert !important;
}
>>> .main_box .content_box img{
	max-width: 100%;
	height: auto;
}
>>> .main_box .content_box td, >>> .main_box .content_box th {
	padding: 5px;
	border: 1px solid #ddd;
}
>>> .main_box .content_box table{
	width: 100%;
	border-collapse: collapse;
}
.content_box{
	overflow: auto;
}
</style>